export default [
    {
        logo: '/static/img/brands/flightschedulepro.svg',
        title: 'Flight Schedule Pro',
        description: 'Easily transfer data for flight schedules, resources, and pilot informtion.'
    },
    {
        logo: '/static/img/brands/talon-system.svg',
        title: 'Talon',
        description: 'Easily transfer data for flight schedules, resources, and pilot informtion.'
    },
    {
        logo: '/static/img/brands/intuit.svg',
        title: 'QuickBooks',
        description: 'Sync invoices, student, and instructor data for seamless billing and record keeping.'
    },
    {
        logo: '/static/img/brands/oracle.svg',
        title: 'NetSuite',
        description: 'Sync invoices, student, and instructor data for seamless billing and record keeping.'
    },
    {
        logo: '/static/img/brands/stripe.svg',
        title: 'Stripe',
        description: 'Simplify payments, subscriptions, and transaction tracking.'
    },
    {
        logo: '/static/img/brands/g-drive.svg',
        title: 'Google Drive',
        description: 'Store, share, and access files seamlessly within your projects.'
    },
    {
        logo: '/static/img/brands/flylingo.svg',
        title: 'FlyLingo',
        description: 'Connect to the top gamified ground school for fun and effective knowledge test prep.'
    }
]